<mat-toolbar class="topbar gap-1.5">
  @if (isPosWorkspace()) {
    @if (!showToggle) {
      <div class="topbar-pos-brand-row">
        <button
          type="button"
          mat-icon-button
          data-overlay-nav-toggle
          class="topbar-pos-brand-row__menu flex justify-center items-center shrink-0"
          (click)="onPosBrandClick()"
          [attr.aria-label]="'shell.openMenuPos' | translate"
          [attr.title]="'shell.openMenuPos' | translate"
        >
          <i class="iconify text-xl! flex" data-icon="solar:hamburger-menu-line-duotone"></i>
        </button>
        @if (!mobileNavOpen) {
          <app-branding
            class="topbar-branding topbar-branding--pos"
            [navigable]="false"
          ></app-branding>
        }
      </div>
    }
  } @else {
    <!-- Mobile Menu -->
    @if (!showToggle) {
      <button mat-icon-button data-overlay-nav-toggle (click)="toggleMobileNav.emit()" class="flex justify-center items-center">
        <i class="iconify text-xl! flex" data-icon="solar:hamburger-menu-line-duotone"></i>
      </button>
    }
    <!--
      Logo Milinco en topbar móvil.
      Con dock, showToggle=true (sin hamburger) pero la marca sigue siendo necesaria:
      en escritorio vive en el rail; aquí solo ≤lg.
    -->
    <app-branding class="topbar-branding lg:hidden!"></app-branding>
  }

  @if (showShellContext()) {
    <span
      class="hidden sm:inline-flex items-center rounded-full px-3 py-1 text-xs font-medium bg-light-primary text-primary shrink-0 max-w-[220px] truncate"
      [attr.title]="shellContextLabel()"
    >
      {{ shellContextLabel() }}
    </span>
  }

  <app-company-switcher />
  <app-location-switcher />
  <!-- --------------------------------------------------------------- -->

  @if (isPosWorkspace()) {
    <span class="topbar-pos-spacer" aria-hidden="true"></span>
    @if (showPosProductSearch()) {
      <app-pos-header-search class="topbar-pos-search" />
    }
    @if (!isPosShell()) {
      <button
        type="button"
        mat-icon-button
        class="flex justify-center items-center"
        (click)="openPosInNewTab()"
        [attr.aria-label]="'shell.openInNewTab' | translate"
        [matTooltip]="'shell.openInNewTab' | translate"
      >
        <i class="iconify text-xl! flex" data-icon="tabler:external-link" aria-hidden="true"></i>
      </button>
    }
    <app-pos-header-ops class="topbar-pos-ops" />
  }

  <span class="flex-1"></span>

  <!-- Mobile Menu -->
  @if (!isPosShell()) {
  <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="topbar-app-hide flex lg:hidden! justify-center items-center">
    <i class="iconify text-xl! flex" data-icon="solar:menu-dots-outline"></i>
  </button>

  <!-- --------------------------------------------------------------- -->
  <!-- Collpase bar -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button (click)="toggleCollpase()" class="topbar-app-hide flex lg:hidden! justify-center">
    <i class="iconify text-xl! flex" data-icon="solar:sort-outline"></i>
  </button>
  }
  @if (isCollapse && !isPosShell()) {
  <div class="header-collpase py-2.5 px-4">
    <div class="flex justify-center gap-2.5">
      <!-- --------------------------------------------------------------- -->
      <!-- Notification Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button class="relative flex items-center justify-center" mat-icon-button [matMenuTriggerFor]="notificationmenu"
        [matBadge]="notificationsUnreadCount() > 0 ? notificationsUnreadCount() : null" matBadgeColor="warn"
        matBadgeSize="small" aria-label="Notifications">
        <i class="iconify flex" data-icon="solar:bell-line-duotone"></i>
        @if (notificationsUnreadCount() > 0) {
        <div class="notify">
          <span class="heartbit"></span> <span class="point"></span>
        </div>
        }
      </button>
      <!-- --------------------------------------------------------------- -->
      <!-- Profile Dropdown -->
      <!-- --------------------------------------------------------------- -->
      <button mat-icon-button extended [matMenuTriggerFor]="profilemenu" aria-label="Profile"
        class="relative flex items-center justify-center profile-btn-dd">
        @if (authSession.user()) {
        <div
          class="rounded-full size-9 shrink-0 bg-primary flex items-center justify-center text-[var(--mat-sys-on-primary)] text-xs font-semibold profile-dd">
          {{ userInitialsDisplay() }}
        </div>
        } @else {
        <img src="/assets/images/profile/user-1.jpg"
          class="rounded-full size-9 object-cover profile-dd flex items-center justify-center" width="36" height="36" alt="" />
        }
      </button>
    </div>
  </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown (menú siempre declarado: refs del collapse) -->
  <!-- --------------------------------------------------------------- -->
  @if (!isPosShell()) {
  <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications"
    [matBadge]="notificationsUnreadCount() > 0 ? notificationsUnreadCount() : null" matBadgeColor="warn"
    matBadgeSize="small" class="topbar-notifications flex items-center justify-center">
    <i class="iconify text-xl! flex" data-icon="solar:bell-line-duotone"></i>
  </button>
  }
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow" (opened)="onNotificationsMenuOpened()">
    <div class="flex items-center justify-between px-7.5 py-4">
      <h6 class="text-base font-semibold">{{ 'header.notifications.title' | translate }}</h6>
      @if (orderNotificationItems().length > 0) {
      <span class="bg-primary text-[var(--mat-sys-on-primary)] px-2 py-1 font-medium rounded text-xs">
        {{ 'header.notifications.newCount' | translate:{ count: orderNotificationItems().length } }}
      </span>
      }
    </div>

    @for(notification of orderNotificationItems(); track notification.id) {
    <button mat-menu-item class="px-7.5! py-3!" (click)="onNotificationClick(notification)">
      <div class="flex gap-4 items-center">
        <span
          class="shrink-0 text-primary bg-light-primary rounded-full size-12! flex items-center justify-center">
          <i-tabler
            [name]="notification.kind === 'service_request' ? 'clipboard-list' : 'receipt'"
            class="text-xl! flex"
          ></i-tabler>
        </span>
        <div class="w-full">
          <div class="flex items-center justify-between w-full">
            <h5 class="text-sm font-semibold">
              @if (notification.kind === 'service_request') {
                {{ 'header.notifications.serviceRequestReceived.title' | translate:{ number: notification.number } }}
              } @else {
                {{ 'header.notifications.orderReceived.title' | translate:{ number: notification.number } }}
              }
            </h5>
            <span class="block text-xs">{{ notification.time }}</span>
          </div>
          <span class="block text-truncate text-xs">
            @if (notification.kind === 'service_request') {
              {{ 'header.notifications.serviceRequestReceived.subtitle' | translate:{ name: notification.customerName || '' } }}
            } @else {
              {{ 'header.notifications.orderReceived.subtitle' | translate }}
            }
          </span>
        </div>
      </div>
    </button>
    } @empty {
    <div class="px-7.5 py-6 text-center text-xs text-muted">
      {{ 'header.notifications.empty' | translate }}
    </div>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- Perfil: un solo trigger según ancho (móvil vs desktop). -->
  <button
    mat-icon-button
    [matMenuTriggerFor]="profilemenu"
    aria-label="Profile"
    class="topbar-profile-mobile items-center justify-center"
  >
    @if (authSession.user()) {
    <div
      class="rounded-full size-9 shrink-0 bg-primary flex items-center justify-center text-[var(--mat-sys-on-primary)] text-xs font-semibold">
      {{ userInitialsDisplay() }}
    </div>
    } @else {
    <img src="/assets/images/profile/user-1.jpg"
      class="rounded-full size-9 object-cover" width="36" height="36" alt="" />
    }
  </button>

  <button mat-button [matMenuTriggerFor]="profilemenu" aria-label="Profile" class="profile-btn topbar-profile-desktop px-2!">
    <div class="flex items-center gap-2">
      @if (authSession.user()) {
      <div
        class="rounded-full object-cover size-9! profile-dd shrink-0 bg-primary flex items-center justify-center text-[var(--mat-sys-on-primary)] text-xs font-semibold">
        {{ userInitialsDisplay() }}
      </div>
      @if (toolbarUserLabel(); as userLabel) {
      <span class="hidden xl:inline text-xs text-muted max-w-[180px] truncate">{{ userLabel }}</span>
      }
      } @else {
      <img src="/assets/images/profile/user-1.jpg" class="rounded-full object-cover size-9! profile-dd" width="36" alt="" />
      }

      <i data-icon="solar:alt-arrow-down-bold" class="iconify text-sm"></i>
    </div>
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd profile-menu-panel" xPosition="before">
    <div class="profile-menu-panel__identity">
      @if (authSession.user(); as sessionUser) {
      <div class="profile-menu-panel__avatar" aria-hidden="true">
        {{ userInitialsDisplay() }}
      </div>
      <div class="profile-menu-panel__meta">
        <h6 class="profile-menu-panel__name">
          <span class="truncate">{{ sessionUser.name }}</span>
          @if (sessionRoleBadge(); as role) {
          <span class="profile-menu-panel__role">{{ role }}</span>
          }
        </h6>
        <span class="profile-menu-panel__email">{{ sessionUser.email }}</span>
        @if (primaryCompanyDisplay(); as companyName) {
        <span class="profile-menu-panel__company">{{ companyName }}</span>
        }
      </div>
      } @else {
      <img
        src="/assets/images/profile/user-1.jpg"
        class="profile-menu-panel__avatar object-cover"
        width="44"
        height="44"
        alt=""
      />
      <div class="profile-menu-panel__meta">
        <h6 class="profile-menu-panel__name">—</h6>
        <span class="profile-menu-panel__email">—</span>
      </div>
      }
    </div>

    @if (showWorkspaceSwitcher()) {
      <button mat-menu-item type="button" (click)="openWorkspacePicker()">
        <i-tabler name="building-store" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.switchBusiness' | translate }}</span>
      </button>
      <mat-divider></mat-divider>
    }
    @for (profile of profileMenuItems(); track profile.id) {
      @if (!profile.logout) {
      <button
        mat-menu-item
        [routerLink]="profile.link"
        [class.profile-menu-panel__item--active]="profile.active"
      >
        <i-tabler [name]="profile.icon" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
        <span class="profile-menu-panel__item-label">{{ profile.titleKey | translate }}</span>
      </button>
      }
    }

    <mat-divider></mat-divider>

    @if (showAppVersion()) {
      <div class="profile-menu-panel__version" title="Versión de la aplicación">
        v{{ appVersionLabel }}
      </div>
    }

    <button mat-menu-item class="profile-menu-panel__sign-out" (click)="signOut()">
      <i-tabler name="logout" matMenuItemIcon class="profile-menu-panel__item-icon" aria-hidden="true"></i-tabler>
      <span class="profile-menu-panel__item-label">{{ 'header.profile.menu.signOut' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
